import {combineReducers} from 'redux';
import widgets from './widgets.reducer';
import dashboard from './dashboard.reducer';
import course from './course.reducer';
import instructorCourse from './instructorCourse.reducer';

const dashboardAppReducers = combineReducers({
    widgets,
    dashboard,
    course,
    instructorCourse
});

export default dashboardAppReducers;


// WEBPACK FOOTER //
// src/main/content/dashboard/store/reducers/index.js